const dateModes = {
  ByDay: 'ByDay',
  ByWeek: 'ByWeek',
  ByMonth: 'ByMonth',
};

export default dateModes;
